<template>
    <div>
        <div class="object-titlebox">
            <div class="object-titlebox-left" v-t="'message.item_edit_help_link_setting'"></div>
            <div class="object-titlebox-right">
                <button class="transparent-button" type="button" v-on:click="checkBrowserToShowHelpLinkSetting()">
                    <img src="@/assets/edit.svg" />
                    <span class="normal-command-text" v-t="'message.common_action_edit'"></span>
                </button>
            </div>
        </div>

        <div class="object-inner-table">
            <table width=100%>
                <!--- 設定内容 --->
                <tr class="object-titlebox" style="display: table-row">
                    <td class="object-titlebox-text" style="padding-left: 20px; width:35%;"
                        v-t="'message.item_setting_value'"></td>
                    <td class="object-titlebox-right" v-t="'message.title_client_enabling'" colspan="2"></td>
                </tr>

                <tr class="setting-item-record">
                    <td class="setting-input-header" v-t="'message.item_buddycom_enable_help_link'"></td>
                    <td v-if="helpLinkSettingInfo.enableFaqLink || helpLinkSettingInfo.enableCustomLink" class="object-right-value" v-t="'message.item_valid'" colspan="2">
                    </td>
                    <td v-else class="object-right-value" v-t="'message.item_invalid'" colspan="2"></td>
                </tr>
            </table>
            <table width=100% v-if="helpLinkSettingInfo.enableFaqLink || helpLinkSettingInfo.enableCustomLink">
                <!--- 表示内容 --->
                <tr class="object-titlebox" style="display: table-row;">
                    <td class="object-titlebox-left" style="padding-left: 20px;" v-t="'message.display_contents'"></td>
                    <td class="object-titlebox-text" v-t="'message.title_client_value'"></td>
                    <td class="object-titlebox-right" v-t="'message.title_client_enabling'"></td>
                </tr>
                <tr class="setting-item-record">
                    <td class="setting-input-header" v-t="'message.item_buddycom_faq_link'"></td>
                    <td v-if="helpLinkSettingInfo.enableFaqLink" class="object-right-value" v-t="'message.item_valid'"
                        colspan="2"></td>
                    <td v-else class="object-right-value" v-t="'message.item_invalid'" colspan="2"></td>
                </tr>
                <tr class="setting-item-record">
                    <td class="setting-input-header" v-t="'message.item_custom_link'"></td>
                    <td v-if="helpLinkSettingInfo.enableCustomLink" class="object-right-value"
                        v-t="'message.item_valid'" colspan="2"></td>
                    <td v-else class="object-right-value" v-t="'message.item_invalid'" colspan="2"></td>
                </tr>
                <tr v-if="helpLinkSettingInfo.enableCustomLink" class="setting-item-record">
                    <td class="setting-input-header" v-t="'message.title_ai_display_name'"></td>
                    <td class="object-value"
                        v-t="helpLinkSettingInfo.enableCustomLink ? helpLinkSettingInfo.customDisplayName : 'message.item_empty'"
                        colspan="2"></td>
                </tr>
                <tr v-if="helpLinkSettingInfo.enableCustomLink" class="setting-item-record">
                    <td class="setting-input-header" v-t="'message.item_custom_link_url'"></td>
                    <td class="object-value"
                        v-t="helpLinkSettingInfo.enableCustomLink ? displayUrl : 'message.item_empty'"
                        colspan="2"></td>
                </tr>
            </table>
        </div>
        <editHelpLinkSetting v-if="showEditHelpLinkSetting" @cancel="showEditHelpLinkSetting = false"
            @save="modifyHelpLinkSetting" :helpLinkSettingInfo="helpLinkSettingInfo" />
    </div>
</template>

<script>
import server from "../../../ServerApi.js";
import commonUtil from '../../../commonutil.js';
import constants from '../../../constants.js';
import EditHelpLinkSetting from "./EditHelpLinkSetting.vue";

export default {
    components: {
        editHelpLinkSetting: EditHelpLinkSetting,
    },

    data() {
        return {
            showEditHelpLinkSetting: false,
            helpLinkSettingInfo: {
                enableFaqLink: true,
                enableCustomLink: false,
                customDisplayName: "",
                url: "",
            },
            displayUrl: "",
        }
    },

    created: function () {
        return this.getInfo();
    },

    methods: {
        getInfo() {
            let self = this;
            server.post('/gethelplinksetting')
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            let settingHelpLink = res.data.settingHelpLink
                            self.showEditHelpLinkSetting = false;
                            self.helpLinkSettingInfo.enableFaqLink = settingHelpLink.enableFaqLink;
                            self.helpLinkSettingInfo.customDisplayName = settingHelpLink.customDisplayName;
                            self.helpLinkSettingInfo.url = settingHelpLink.url;
                            self.helpLinkSettingInfo.enableCustomLink = settingHelpLink.enableCustomLink;
                            this.setDisplayUrl(settingHelpLink.url);
                            break;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            break;
                        default:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "getInfo").replace("{code}", res.data.status));
                            break;
                    }
                })
        },
        checkBrowserToShowHelpLinkSetting() {
            var userAgent = window.navigator.userAgent.toLowerCase();
            if ((userAgent.indexOf('msie') !== -1) ||
                (userAgent.indexOf('trident') !== -1)) {
                commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_browser"));
                return;
            }
            if (!this.$root.store.appData.tenantAdminUser) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_operate_no_tenantAdmin_privilege"));
                return;
            }
            this.showEditHelpLinkSetting = true;
        },
        modifyHelpLinkSetting(helpLinkSettingRequest) {
            this.showEditHelpLinkSetting = false;
            server.post('/modifyhelplinksetting', helpLinkSettingRequest)
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            commonUtil.notifyMessage(this, 'Success', commonUtil.getMessageText(this.$i18n, "item_help_link_setting_added"));
                            this.helpLinkSettingInfo.enableFaqLink = helpLinkSettingRequest.enableFaqLink;
                            this.helpLinkSettingInfo.customDisplayName = helpLinkSettingRequest.customDisplayName;
                            this.helpLinkSettingInfo.url = helpLinkSettingRequest.url;
                            this.helpLinkSettingInfo.enableCustomLink = helpLinkSettingRequest.enableCustomLink;
                            break;
                        default:
                            commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "modifyHelpLinkSetting").replace("{code}", res.data.status));
                            break;
                    }

                    this.setDisplayUrl(helpLinkSettingRequest.url);
                })
                .catch(function (error) {
                    commonUtil.putExceptionErrorMessage(this, "modifyhelplinksetting", error);
                })
        },
        setDisplayUrl(url) {
            if (url.length > 150) {
                this.displayUrl = url.slice(0, 130) + "...";
            } else {
                this.displayUrl = url;
            }
        }
    }
}
</script>

<style scoped>
.setting-item-record {
    border-bottom: 1px solid #eee;
    text-align: left;
}

.object-right-value {
    width: 65%;
    text-align: right;
    padding-right: 30px;
    color: #848991;
}

.object-value {
    width: 65%;
    color: #848991;
    text-align: left;
    padding-right: 80px;
    overflow-wrap: anywhere;
}

.setting-input-header {
    width: 35%;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 14px;
    text-align: left;
    vertical-align: middle;
}
</style>

